import React from "react";

export const Location = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.6 10.5002C16.6 13.4402 11.8 18.3002 11.8 18.3002C11.8 18.3002 7 13.4402 7 10.5002C7 7.4402 9.46 5.7002 11.8 5.7002C14.14 5.7002 16.6 7.4402 16.6 10.5002Z"
      stroke="#0D0C1C"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.8 12.3002C12.7941 12.3002 13.6 11.4943 13.6 10.5002C13.6 9.50608 12.7941 8.7002 11.8 8.7002C10.8059 8.7002 10 9.50608 10 10.5002C10 11.4943 10.8059 12.3002 11.8 12.3002Z"
      stroke="#0D0C1C"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
